import { render, staticRenderFns } from "./AppreciationEmail.vue?vue&type=template&id=084754d8&"
import script from "./AppreciationEmail.vue?vue&type=script&lang=js&"
export * from "./AppreciationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports